type OptimizationDebugEntry = {
  timestamp: string;
  source: string;
  message: string;
  data?: unknown;
};

const MAX_ENTRIES = 1000;

const isBrowser = typeof window !== 'undefined';

const globalObject = (isBrowser ? window : globalThis) as typeof globalThis & {
  __optimizationDebugLogs?: OptimizationDebugEntry[];
};

const logStore: OptimizationDebugEntry[] = globalObject.__optimizationDebugLogs ?? [];

if (!globalObject.__optimizationDebugLogs) {
  globalObject.__optimizationDebugLogs = logStore;
}

const listeners = new Set<(entry: OptimizationDebugEntry) => void>();

function addEntry(entry: OptimizationDebugEntry) {
  logStore.push(entry);
  if (logStore.length > MAX_ENTRIES) {
    logStore.splice(0, logStore.length - MAX_ENTRIES);
  }

  listeners.forEach(listener => {
    try {
      listener(entry);
    } catch (error) {
    }
  });
}

export function optimizationDebugLog(
  source: string,
  message: string,
  data?: unknown,
  options: { console?: boolean } = { console: true }
) {
  const entry: OptimizationDebugEntry = {
    timestamp: new Date().toISOString(),
    source,
    message,
    data
  };

  addEntry(entry);

  if (options.console !== false) {
    if (data !== undefined) {
    } else {
    }
  }
}

export function subscribeOptimizationLogs(listener: (entry: OptimizationDebugEntry) => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getOptimizationDebugLogs() {
  return [...logStore];
}

export function clearOptimizationDebugLogs() {
  logStore.length = 0;
}

export function downloadOptimizationDebugLogs(filename?: string) {
  if (!isBrowser) {
    return;
  }

  const safeFilename = filename ?? `optimization-debug-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
  const blob = new Blob([JSON.stringify(logStore, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = safeFilename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

if (isBrowser) {
  window.downloadOptimizationDebugLogs = downloadOptimizationDebugLogs;
  window.clearOptimizationDebugLogs = clearOptimizationDebugLogs;
  window.getOptimizationDebugLogs = getOptimizationDebugLogs;
}

declare global {
  interface Window {
    __optimizationDebugLogs?: OptimizationDebugEntry[];
    downloadOptimizationDebugLogs?: (filename?: string) => void;
    clearOptimizationDebugLogs?: () => void;
    getOptimizationDebugLogs?: () => OptimizationDebugEntry[];
  }
}

export type { OptimizationDebugEntry };

export {}
